var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fffefa",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.534,32H1.268A1.277,1.277,0,0,0,0,33.284V48.522a1.277,1.277,0,0,0,1.268,1.284H16.534a1.281,1.281,0,0,0,1.272-1.284V33.284A1.281,1.281,0,0,0,16.534,32ZM5.382,47.262H2.742v-8.5H5.386v8.5ZM4.062,37.6a1.53,1.53,0,1,1,1.53-1.53A1.531,1.531,0,0,1,4.062,37.6Zm11.212,9.658H12.635V43.129c0-.986-.02-2.254-1.371-2.254-1.375,0-1.586,1.073-1.586,2.182v4.205H7.039v-8.5H9.571v1.161h.036a2.78,2.78,0,0,1,2.5-1.371c2.671,0,3.168,1.761,3.168,4.05Z",
    transform: "translate(7.098 -24.903)",
    fill: "#816920"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.cd272135.svg";
export { ForwardRef as ReactComponent };